// extracted by mini-css-extract-plugin
export default {"ModalAppBar":"Header_ModalAppBar__QcI9C","ModalToolbar":"Header_ModalToolbar__hUE6D","Title":"Header_Title__MV+mc","ModalControls":"Header_ModalControls__rfDzF"};